import { Grid } from "@material-ui/core";
import React from "react";
import Dialog from 'ui/Dialog';
import { TextField } from "ui/Form/TextField";
import axios from "axios";
import { InfoBarContext } from "contexts/InfoBarContext";
import Autocomplete from "ui/Autocomplete";
import { Level } from "__types__";


export interface EditFamilyProps {
  open: boolean;
  onClose: () => void;

  current?: any;
}

const defaultValues = {
  name: "",
  level: null as Level
};
export const EditFamily: React.FC<EditFamilyProps> = ({ open, onClose, current }) => {
  const [levels, setLevels] = React.useState<Level[]>([]);
  const [formValues, setFormValues] = React.useState(defaultValues);
  const [isFormSubmited, setFormSubmited] = React.useState(false);


  React.useEffect(() => {
    axios('/api/v1/tutoring/levels')
      .then(res => {
        setLevels(res.data)
      })
  }, []);

  React.useEffect(() => {
    if (current) {
      setFormValues({
        name: current.name,
        level: current.level
      })
    }
  }, [current]);

  const handleInputChange = React.useCallback(
    (event: any) => {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.value,
      });
    },
    [formValues]
  );


  const { setInfo } = React.useContext(InfoBarContext);

  const handleClose = () => {
    onClose();
  };

  const onSubmit = () => {
    setFormSubmited(true);

    if (!Boolean(formValues.level) || !Boolean(formValues.name))
      return;

    if (current) {
      axios.put("/api/v1/tutoring/courses/" + current.id, {
        name: formValues.name,
        level_id: formValues.level.id,
      }).then(async res => {
        setInfo({
          type: "success",
          message: "Matiere modifier avec succès!"
        })
        handleClose();
        window.location.reload();
      })
    } else {
      axios.post("/api/v1/tutoring/courses", {
        name: formValues.name,
        level_id: formValues.level.id,
      }).then(async res => {
        setInfo({
          type: "success",
          message: "Matiere ajouter avec succès!"
        })
        handleClose();
        window.location.reload();
      })
    }
  };

  return (

    <Dialog
      title={Boolean(current) ? "Modifier " : "Ajouter"}
      confirmButtonTitle={Boolean(current) ? "Modifier " : "Ajouter"}
      open={open}
      handleConfirm={onSubmit}
      handleClose={handleClose}
    >
      <Grid container spacing={10}>
        <Grid item xs={12}>
          <Autocomplete
            required
            label="Nievau"
            options={levels}
            getOptionLabel={(option: any) => option.name}
            onChange={(event: any, newValue: any) => {
              setFormValues({
                ...formValues,
                "level": newValue,
              });
            }}
            error={isFormSubmited && !Boolean(formValues.level)}
            helperText={isFormSubmited && !Boolean(formValues.level) && "Veuillez saisir le niveau"}
            value={formValues.level}
            getOptionSelected={(option: any, val: any) => option.id === val.id}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            name="name"
            fullWidth
            label="Matiere"
            onChange={handleInputChange}
            error={isFormSubmited && !Boolean(formValues.name)}
            helperText={isFormSubmited && !Boolean(formValues.name) && "Veuillez saisir la matiere"}
            value={formValues.name}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default EditFamily;
